<rt-box [hasHoverState]="true" variant="padding-small">
  <rt-icon [name]="icon()" size="medium" margin-right />
  <div layout-vertical layout-flex-1-1 min-width-0>
    <div layout layout-align-items-center min-width-0>
      @if (truncateHeading()) {
        <rt-heading [truncated]="true" min-width-0>
          <rt-truncate
            #headingTruncate
            [rtTooltip]="heading()"
            [rtTooltipPosition]="'below'"
            [rtTooltipEnabled]="headingTruncate.isTruncated"
            >{{ heading() }}</rt-truncate
          >
        </rt-heading>
      } @else {
        <rt-heading>{{ heading() }}</rt-heading>
      }
    </div>
    <rt-heading variant="subheading normal">{{ subheading() }}</rt-heading>
  </div>
  <div>
    <rt-icon [name]="'chevron-right'" class="arrow-icon" />
  </div>
</rt-box>
@if (recommended()) {
  <rt-badge
    class="recommended-badge transform-none"
    color="primary"
    [text]="'app.interview.recommended' | translate"
  />
}
